module.exports = __webpack_public_path__ + "static/media/study 201108.bfe156c0.png";